import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import App from "./App.tsx";
import { MarkdownPage } from "./components/MarkdownPage.tsx";
import "./index.css";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import { LoginForm } from "./components/LoginForm.tsx";
import ModalWrapper from "./components/ModalWrapper.tsx";

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<App />
			</ProtectedRoute>
		),
	},
	{
		path: "/login",
		element: <LoginForm />,
	},
	{
		path: "/paginas/:filename",
		element: (
			<ProtectedRoute>
				<MarkdownPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/acoes/:action",
		element: (
			<ProtectedRoute>
				<ModalWrapper />
			</ProtectedRoute>
		),
	},
	{
		path: "*",
		element: <Navigate to="/" replace />,
	},
]);

createRoot(document.getElementById("root")!).render(
	<StrictMode>
			<RouterProvider router={router} />
	</StrictMode>
);
